const ModalActionTypes = {
  TOGGLE_MODAL_VIEW: 'TOGGLE_MODAL_VIEW',
  TOGGLE_MODAL_CURRENT: 'TOGGLE_MODAL_CURRENT',
};

export default ModalActionTypes;
